import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateMeetingPrepTemplates, updateMeetingPrepTemplatesRQCache } from './useMeetingPrepTemplates';

/**
 * The endpoint is a full-object replace, so send the loaded template with the edited fields applied
 * rather than a partial. Server-managed fields in the body are ignored — the server carries the stored
 * values forward.
 */
export function useUpdateMeetingPrepTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.MeetingPrepTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (template: Api.MeetingPrepTemplate) => {
			return userSession.webServiceHelper.callAsync<Api.MeetingPrepTemplate>(
				`meetingPrep/templates/${template.id}`,
				'PUT',
				template
			);
		},
		onError,
		onSuccess: template => {
			updateMeetingPrepTemplatesRQCache(template);
			onSuccess?.(template);
		},
		onSettled: () => {
			invalidateMeetingPrepTemplates();
		},
	});
}
